export default __webpack_public_path__ + "static/media/soccerball_on.64192693.png";